import FormWithDescription from '../../FormWithDescription';
import RemoveDomainWizard from './RemoveDomainWizard';
import DnsTable from './DnsTable';

export default function DomainStatus(props) {
  const { blogId, validCname, validCnameWww, blog } = props;
  return (
    <FormWithDescription
      title="Configure domain"
      description={`If you remove your domain, your blog will only be available on ${blogId}.truvvl.blog and no longer on ${blog.domain}`}
    >
      {validCname || validCnameWww ? (
        'Your domain is configured successfully.'
      ) : (
        <>
          <p>
            Domain status: Initializing. Make sure you have changed your DNS
            records for {blog.domain} to these records. DNS changes can take up
            to 24 hours to reflect.
          </p>
          <DnsTable
            validCname={validCname}
            blogId={blogId}
            validCnameWww={validCnameWww}
            showStatus
          />
          <p className="tw-pt-4">
            Unable to set ALIAS or CNAME record for @?{' '}
            <a
              href={`/help/article/how-to-add-your-own-domain#alternatives-for-registrars-that-don-t-support-alias-or-cname-record-for`}
              target="_blank"
              rel="nofollow noreferrer noopener"
              className="tw-text-green-600 hover:tw-text-green-500 tw-underline hover:tw-underline"
            >
              See your options here
            </a>
          </p>
        </>
      )}
      <RemoveDomainWizard {...props} />
    </FormWithDescription>
  );
}
